import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const ProductArticle = {
  namespaced: true,
  state: {
    articles: undefined
  },
  mutations: {
    initialize (state, genko) {
      state.articles = genko.map(function (data) {
        let post = {}
        post['id'] = data.id
        post['title'] = data.title.rendered
        post['content'] = data.content.rendered
        post['worktitle'] = data.work_info.worktitle[0]
        post['workexcerpt'] = data.work_info.workexcerpt[0]
        post['workeimage'] = data.top_image_src
        post['featuredimage'] = data.featured_image_src
        post['primaryColor'] = data.work_info.workprimarycolor !== undefined ? data.work_info.workprimarycolor[0] : 'ホワイト'
        return post
      })
    }
  }
}

const BlogArticle = {
  namespaced: true,
  state: {
    articles: undefined,
    url: 'https://yuyamadesign.com/media/wp-json/contact-form-7/v1/contact-forms/3/feedback'
  },
  mutations: {
    initialize (state, genko) {
      state.articles = genko.map(function (data) {
        let post = {}
        post['id'] = data.id
        post['title'] = data.title.rendered
        post['content'] = data.content.rendered
        post['excerpt'] = data.excerpt.rendered
        post['link'] = data.guid.rendered
        post['worktitle'] = (data.work_info.worktitle !== undefined) ? data.work_info.worktitle[0] : ''
        post['workexcerpt'] = (data.work_info.workexcerpt !== undefined) ? data.work_info.workexcerpt[0] : ''
        post['workeimage'] = data.top_image_src
        post['featuredimage'] = data.featured_image_src
        post['format'] = data.format
        return post
      })
    }
  }
}

export default new Vuex.Store({
  state: {
    isScrolled: false,
    mq: {
      sm: 576,
      md: 780,
      mdlg: 1140,
      lg: 1500,
      xl: 1800
    },
    currentMq: undefined,
    isPageLoaded: false,
    minPostsForNotTablet: 16,
    minPostsForTablet: 16,
    minPostsForNotTabletBlog: 8,
    minPostsForTabletBlog: 8
  },
  modules: {
    ProductArticle,
    BlogArticle
  },
  mutations: {
    updateScrollState (state, flag) {
      state.isScrolled = flag
    },
    updateMediaQuery (state) {
      let windowWidth = window.innerWidth
      if (windowWidth > state.mq.xl) {
        state.currentMq = 'query-xl'
      } else if (windowWidth > state.mq.lg && state.mq.xl >= windowWidth) {
        state.currentMq = 'query-lg'
      } else if (windowWidth > state.mq.mdlg && state.mq.lg >= windowWidth) {
        state.currentMq = 'query-mdlg'
      } else if (windowWidth > state.mq.md && state.mq.mdlg >= windowWidth) {
        state.currentMq = 'query-md'
      } else {
        state.currentMq = 'query-sm'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js